module.exports = __webpack_public_path__ + "static/img/leng y mat.8c3605ba.png";